export default "__VITE_ASSET__QyhuXDiR__"